import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, PageHeader, Button, Empty, Spin } from 'antd'
import useSWR from 'swr'
import { useSnapshot } from 'valtio'

import tableStore from '../../lib/store/feedback_table'
import FeedbackService from '../../network/services/feedback'
import { serialize } from '../../network/request'
import FeedbackTable from './FeedbackTable'

const FeedbackPage = () => {
  return (
    <PageHeader title="All Feedbacks">
      <Card>
        <FeedbackTableWrapper />
      </Card>
    </PageHeader>
  )
}

const FeedbackTableWrapper = () => {
  const { state } = useSnapshot(tableStore)

  // use this to preload
  const { data: response, error } = useSWR(
    serialize(FeedbackService.getAll, { page: 1, limit: state.pageSize, ...state.filters })
  )

  if (error) {
    console.log(error)
    return <Empty description={error?.message ?? 'Please try again later'} />
  }

  console.log(response)

  if (!response) {
    return <Spin />
  }

  const { total } = FeedbackService.toPaginate(response)

  return (
    <>
      <FeedbackTable total={total} />
      {/* preload next page */}
      {state.currentPage * state.pageSize < total && (
        <div style={{ display: 'none' }}>
          <FeedbackTable total={total} overridePage={state.currentPage + 1} />
        </div>
      )}
    </>
  )
}

export default FeedbackPage
